"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SankeyMenuConfigurationNodesAttributes = exports.OpenSankeyConfigurationNodesAttributes = void 0;
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const OpenSankeyConfigurationNodesAttributes = (t, data, set_data, multi_selected_nodes, menu_for_style, selected_style_node) => {
    const parameter_to_modify = (menu_for_style) ? data.style_node : data.nodes;
    const selected_parameter = (menu_for_style) ? [data.style_node[selected_style_node]] : multi_selected_nodes.current;
    const isAllNodeVisible = () => {
        let visible = false;
        selected_parameter.map(d => visible = (d.shape_visible || d.not_to_scale) ? true : visible);
        return visible;
    };
    const isAllNodeRect = () => {
        let rect = true;
        if (selected_parameter.length > 0) {
            selected_parameter.map(d => rect = (d.shape !== 'rect') ? false : rect);
        }
        else {
            rect = false;
        }
        return rect;
    };
    const getBrowserName = () => {
        const browserInfo = navigator.userAgent;
        let browser;
        if (browserInfo.includes('Opera') || browserInfo.includes('Opr')) {
            browser = 'Opera';
        }
        else if (browserInfo.includes('Edg')) {
            browser = 'Edge';
        }
        else if (browserInfo.includes('Chrome')) {
            browser = 'Chrome';
        }
        else if (browserInfo.includes('Safari')) {
            browser = 'Safari';
        }
        else if (browserInfo.includes('Firefox')) {
            browser = 'Firefox';
        }
        else {
            browser = 'unknown';
        }
        return browser;
    };
    const isAllNodeCircle = () => {
        let circle = true;
        if (selected_parameter.length > 0) {
            selected_parameter.map(d => circle = (d.shape !== 'ellipse') ? false : circle);
        }
        else {
            circle = false;
        }
        return circle;
    };
    const isAllNodeColorSustainable = () => {
        let colorS = true;
        if (selected_parameter.length > 0) {
            selected_parameter.map(d => colorS = (!d.colorSustainable) ? false : colorS);
        }
        else {
            colorS = false;
        }
        return colorS;
    };
    const displayedValueNodeWidth = () => {
        let display_width = true;
        let width = 0;
        if (selected_parameter.length != 0) {
            width = selected_parameter[0].node_width;
        }
        selected_parameter.map((d) => {
            display_width = (d.node_width == width) ? display_width : false;
        });
        return (display_width) ? width : 0;
    };
    const displayedValueNodeHeight = () => {
        let display_height = true;
        let width = 0;
        if (selected_parameter.length != 0) {
            width = selected_parameter[0].node_height;
        }
        selected_parameter.map((d) => {
            display_height = (d.node_height == width) ? display_height : false;
        });
        return (display_height) ? width : 0;
    };
    // Tableau d'elements de sous-menu attribut de noeuds
    return [
        /* Visibilite du noeud */
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row, key: 'node_visibility' },
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('Noeud.apparence.Visibilité'))),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 1 },
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'noeud.apparence.tooltips.1', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'noeud.apparence.tooltips.1' },
                        t('Noeud.apparence.tooltips.Visibilité'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.FormCheck, { inline: true, type: 'switch', checked: isAllNodeVisible(), onChange: evt => {
                            Object.values(parameter_to_modify).filter(f => selected_parameter.map(d => d.idNode).includes(f.idNode)).map(d => d.shape_visible = evt.target.checked);
                            set_data(Object.assign({}, data));
                        } })))),
        /* Couleur du noeud */
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                react_1.default.createElement(react_bootstrap_1.FormLabel, { style: { color: (isAllNodeVisible()) ? '#555555' : '#DADADA' } }, t('Noeud.apparence.Couleur'))),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 3 },
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'noeud.apparence.tooltips.2', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'noeud.apparence.tooltips.2' },
                        t('Noeud.apparence.tooltips.Couleur'),
                        " ") }, (getBrowserName() === 'Firefox') ? react_1.default.createElement(react_bootstrap_1.Form.Control, { type: 'color', disabled: !isAllNodeVisible(), value: (selected_parameter.length == 1) ? selected_parameter[0].color : '#ffffff', onChange: evt => {
                        Object.values(parameter_to_modify).filter(f => selected_parameter.map(d => d.idNode).includes(f.idNode)).map(d => d.color = evt.target.value);
                        set_data(Object.assign({}, data));
                    } }) : react_1.default.createElement(react_bootstrap_1.Form.Control, { type: 'color', disabled: !isAllNodeVisible(), value: (selected_parameter.length == 1) ? selected_parameter[0].color : '#ffffff', onChange: evt => {
                        Object.values(parameter_to_modify).filter(f => selected_parameter.map(d => d.idNode).includes(f.idNode)).map(d => d.color = evt.target.value);
                        // set_data({ ...data })
                    }, onBlurCapture: () => {
                        set_data(Object.assign({}, data));
                    } })))),
        /* Figer la couleur */
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                react_1.default.createElement(react_bootstrap_1.FormLabel, { style: { color: (isAllNodeVisible()) ? '#555555' : '#DADADA' } }, t('Noeud.apparence.CouleurPérenne'))),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 3 },
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'noeud.apparence.tooltips.3', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'noeud.apparence.tooltips.3' },
                        t('Noeud.apparence.tooltips.CouleurPérenne'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.Form.Check, { type: 'checkbox', 
                        //Si la valeur est a true alors la couleur des noeuds reste celle sélectionné loreque que l'on affiche les flux celon leur étiquettes
                        checked: isAllNodeColorSustainable(), onChange: evt => {
                            const checked = evt.target.checked;
                            Object.values(parameter_to_modify).filter(f => selected_parameter.map(d => d.idNode).includes(f.idNode)).map(d => d.colorSustainable = checked);
                            set_data(Object.assign({}, data));
                        } })))),
        /* Forme du noeud */
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                react_1.default.createElement(react_bootstrap_1.FormLabel, { style: { color: (isAllNodeVisible()) ? '#555555' : '#DADADA' } }, t('Noeud.apparence.Forme'))),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'noeud.apparence.tooltips.4', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'noeud.apparence.tooltips.4' },
                        t('Noeud.apparence.tooltips.Forme'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.FormCheck, { value: "ellipse", type: 'radio', label: t('Noeud.apparence.Cercle'), disabled: !isAllNodeVisible(), checked: isAllNodeCircle(), onChange: evt => {
                            Object.values(parameter_to_modify).filter(f => selected_parameter.map(d => d.idNode).includes(f.idNode)).map(d => d.shape = evt.target.value);
                            set_data(Object.assign({}, data));
                        } }))),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'noeud.apparence.tooltips.5', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'noeud.apparence.tooltips.5' },
                        t('Noeud.apparence.tooltips.Forme'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.FormCheck, { value: "rect", type: 'radio', label: t('Noeud.apparence.Rectangle'), disabled: !isAllNodeVisible(), checked: isAllNodeRect(), onChange: evt => {
                            Object.values(parameter_to_modify).filter(f => selected_parameter.map(d => d.idNode).includes(f.idNode)).map(d => d.shape = evt.target.value);
                            set_data(Object.assign({}, data));
                        } })))),
        /* Largeur minimale du noeud */
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                react_1.default.createElement(react_bootstrap_1.FormLabel, { style: { color: (isAllNodeVisible()) ? '#555555' : '#DADADA' } }, t('Noeud.apparence.TML'))),
            react_1.default.createElement(react_bootstrap_1.Col, null,
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'noeud.apparence.tooltips.6', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'noeud.apparence.tooltips.6' },
                        t('Noeud.apparence.tooltips.TML'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.FormControl, { min: 0, max: 100, type: 'number', value: displayedValueNodeWidth(), disabled: !isAllNodeVisible(), onChange: evt => {
                            selected_parameter.map(d => d.node_width = +evt.target.value);
                            //set_multi_selected_nodes(multi_selected_nodes)
                            Object.values(parameter_to_modify).filter(f => selected_parameter.map(d => d.idNode).includes(f.idNode)).map(d => d.node_width = +evt.target.value);
                            set_data(Object.assign({}, data));
                        } }))),
            react_1.default.createElement(react_bootstrap_1.Col, { style: { color: (isAllNodeVisible()) ? '#555555' : '#DADADA' } }, "px")),
        /* Hauteur minimale du noeud */
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                react_1.default.createElement(react_bootstrap_1.FormLabel, { style: { color: (isAllNodeVisible()) ? '#555555' : '#DADADA' } }, t('Noeud.apparence.TMH'))),
            react_1.default.createElement(react_bootstrap_1.Col, null,
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'noeud.apparence.tooltips.7', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'noeud.apparence.tooltips.7' },
                        t('Noeud.apparence.tooltips.TMH'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.FormControl, { min: 0, max: 100, type: 'number', value: displayedValueNodeHeight(), disabled: !isAllNodeVisible(), onChange: evt => {
                            //set_multi_selected_nodes(multi_selected_nodes)
                            Object.values(parameter_to_modify).filter(f => selected_parameter.map(d => d.idNode).includes(f.idNode)).map(d => d.node_height = +evt.target.value);
                            set_data(Object.assign({}, data));
                        } }))),
            react_1.default.createElement(react_bootstrap_1.Col, { style: { color: (isAllNodeVisible()) ? '#555555' : '#DADADA' } }, "px"))
    ];
};
exports.OpenSankeyConfigurationNodesAttributes = OpenSankeyConfigurationNodesAttributes;
const SankeyMenuConfigurationNodesAttributes = (t, menu_configuration_nodes_attributes) => {
    //Function that check if all selected nodes have the same value for some parameter
    return react_1.default.createElement(react_bootstrap_1.Tab, { eventKey: "nodes_desc", title: t('Noeud.apparence.apparence'), disabled: /*!(node.colorParameter == 'local')*/ false },
        react_1.default.createElement(react_bootstrap_1.Form, null, menu_configuration_nodes_attributes.map((c, i) => {
            return react_1.default.createElement(react_1.default.Fragment, { key: i }, c);
        })));
};
exports.SankeyMenuConfigurationNodesAttributes = SankeyMenuConfigurationNodesAttributes;
